// Stand der Statistik-Einwilligung in der App (Firebase Analytics), ohne native Aufrufe.
// Bewusst winzig und nur mit Modulen aus dem Start-Bundle (consentSpeicher, platform): das
// Dashboard fragt hier, ob der Erststart nachgeladen werden muss, ohne src/lib/appStatistik.ts
// (native Aufrufe) ins Web zu ziehen. Details: src/lib/appStatistik.ts.
import { gespeicherteEinwilligung } from "@/lib/consentSpeicher";
import { isNative } from "@/lib/platform";

export const STATISTIK_PLUGIN = "FirebaseAnalytics";

type CapacitorPlugins = {
  /** Von der nativen Hülle injiziert: alle Plugins dieses Store-Builds. */
  PluginHeaders?: { name?: string }[];
  isPluginAvailable?: (name: string) => boolean;
};

/** Bringt die installierte App Firebase Analytics mit? Im Web und in älteren Builds false. */
export function appStatistikVerfuegbar(): boolean {
  try {
    if (!isNative()) return false;
    const c = (window as unknown as { Capacitor?: CapacitorPlugins }).Capacitor;
    // PluginHeaders kommt immer von der Hülle; isPluginAvailable kennt nur per registerPlugin
    // angemeldete Plugins und dient nur als Rückfall.
    if (Array.isArray(c?.PluginHeaders)) return c.PluginHeaders.some((h) => h?.name === STATISTIK_PLUGIN);
    return c?.isPluginAvailable?.(STATISTIK_PLUGIN) === true;
  } catch {
    return false;
  }
}

/** Hat die Person auf diesem Gerät der Statistik zugestimmt? */
export function appStatistikErlaubt(): boolean {
  return gespeicherteEinwilligung()?.analytics === true;
}

/** Erststart: nur fragen, wenn Firebase da ist und auf diesem Gerät noch nichts entschieden wurde. */
export function appStatistikFragbar(): boolean {
  return appStatistikVerfuegbar() && gespeicherteEinwilligung() === null;
}
